function mergePartner(internals, externals){
  let result = []

  for (let index = 0; index < internals.length; index++) {
    const element = internals[index];
    result.push({
      type: 'internal',
      ...element
    })
  }

  for (let index = 0; index < externals.length; index++) {
    const element = externals[index];
    result.push({
      type: 'external',
      ...element
    })
  }

  return result
}

export { mergePartner }
